module.exports = __webpack_public_path__ + "img/coupon_ysy.555d2a12.svg";